import React from "react";
import { useState } from "react";
import { ButtonBurger } from "../ButtonBurger";
import { useNavigate } from "react-router-dom";
import CompanyDropdown from "../../others/CompanyDropdown/CompanyDropdown";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/combineReducer";
import { setProfileUser } from "../../../store/user/actions";
import { dropDownItems } from "./dropdownItems";
import { Link } from "react-router-dom";
import { Company, DropDownCompany } from "./Navbar.type";
import { FranchiseLogo, TenantIndicator } from "../FranchiseBranding";
import { Info, TriangleAlert } from "lucide-react";
import { CUENTA_CORRIENTE } from "../../../constants/routes";
import {
  getDisplayClientCode,
  isFranchiseTenant,
} from "../../../utils/franchise/franchiseAbsenteeismMenu";

const rolesDictionary: { [key: string]: string } = {
  'SUPER_ADMIN_LAVORIS': 'Super Administrador Lavoris',
  'ADMIN_LAVORIS': 'Administrador Lavoris',
  'COMPANY_ADMIN': 'Administrador de la Empresa',
  'COMPANY_ACCOUNTANT': 'Contador de la Empresa',
  'COMPANY_CANDIDATE': 'Candidato de Empresa',
  'COMPANY_EMPLOYEE': 'Empleado de Empresa',
  'PARTICULAR_CLIENT': 'Cliente Particular',
  'COMPANY_CONTACT': 'Empleado de Empresa',
  'ABSENTEE_DOCTOR': 'Doctor de ausentismo',
  'OCCUPATIONAL_DOCTOR': 'Doctor de medicina laboral',
  'PROFESSIONAL': 'Profesional',
  'RRHH': 'RRHH',
  'RRHH_APPOINTMENTS': 'RRHH turnos y resultado de turnos',
  'CANDIDATE_APPOINTMENTS': 'RRHH turnos Postulantes',
  'RRHH_APPOINTMENTS_AND_ABSENTEE': 'RRHH turnos S/Res',
  'RRHH_RESULT': 'RRHH Resultados',
  'RRHH_ABSENTEE': 'RRHH ausentismos y resultado de ausentismos',
  'ADM_ABSENTEE': 'ADM Ausentismo',
  'ACCOUNTANT': 'Contador',
  'ASESOR': 'Asesor',
}

interface NavBarProps {
  onMobileMenuToggle?: () => void;
}

function NavBar({ onMobileMenuToggle }: NavBarProps) {
  let dispatch = useDispatch();
  const reduxStore = useSelector((state: RootState) => state.user);
  const franchiseState = useSelector((state: RootState) => state.franchise);
  const isFranchise = isFranchiseTenant(franchiseState);
  const navigate = useNavigate();
  const [companies, setCompanies] = useState(dropDownItems);
  const [profile, setProfile] = useState(reduxStore);

  // HANDLE ROLE CHANGES
  const chosenRole: string = reduxStore?.currentRole;
  const DROPDOWN: any = {
    COMPANY_ADMIN: (
      <CompanyDropdown
        menuItems={companies}
        handleChosenCompany={(item: DropDownCompany) =>
          handleChosenCompany(item)
        }
      />
    ),
    ASESOR: (
      <div className="asesor-no-profile">
        {/* No muestra perfil ni dropdown para ASESOR */}
      </div>
    ),
    PARTICULAR_CLIENT: (
      <Link to="/Cuenta">
        <img
          src="/images/Profile.svg"
          className="profile-image"
          alt="Profile"
        />
      </Link>
    ),
    RRHH: (
      <img
        src="/images/Profile.svg"
        className="profile-image"
        alt="Profile"
      />
    ),
    RRHH_APPOINTMENTS: (
      <img
        src="/images/Profile.svg"
        className="profile-image"
        alt="Profile"
      />
    ),
    CANDIDATE_APPOINTMENTS: (
      <img
        src="/images/Profile.svg"
        className="profile-image"
        alt="Profile"
      />
    ),
    RRHH_APPOINTMENTS_AND_ABSENTEE: (
      <img
        src="/images/Profile.svg"
        className="profile-image"
        alt="Profile"
      />
    ),
    RRHH_RESULT: (
      <img
        src="/images/Profile.svg"
        className="profile-image"
        alt="Profile"
      />
    ),
    RRHH_ABSENTEE: (
      <img
        src="/images/Profile.svg"
        className="profile-image"
        alt="Profile"
      />
    ),
    ADM_ABSENTEE: (
      <img
        src="/images/Profile.svg"
        className="profile-image"
        alt="Profile"
      />
    ),
    ACCOUNTANT: (
      <img
        src="/images/Profile.svg"
        className="profile-image"
        alt="Profile"
      />
    ),
  };

  //Helper Functions
  const handleChosenCompany = (item: DropDownCompany) => {
    let chosenProfile = profile?.companies?.find(
      (company: Company) => company.fantasyName === item.title,
    );
    //Check if dropdown click was on a Company. If so, update Redux
    if (chosenProfile) {
      let updatedProfile = profile;
      updatedProfile.currentCompany = chosenProfile;
      const setProfileRedux = async () => {
        try {
          let response = dispatch(setProfileUser(updatedProfile));
          let currentCompany: string | undefined =
            response.payload.currentCompany?.fantasyName;
          if (currentCompany === updatedProfile.currentCompany.fantasyName) {
            setTimeout(() => window.location.reload(), 500);
          }
        } catch (e) {
          console.log(e);
        }
      };
      setProfileRedux();
    } else {
      item.title === "Ver mi cuenta" && navigate(`/Cuenta/Datos-Empresa`);
    }
  };

  const getCodClient = () => {
    if (!profile) return "---";
    if (isFranchise) {
      if (profile.currentCompany) {
        return getDisplayClientCode(profile.currentCompany, true);
      }
      if (profile.companies?.length) {
        return getDisplayClientCode(profile.companies[0], true);
      }
      return "---";
    }
    if (profile.currentCompany?.managerId) {
      return profile.currentCompany.managerId;
    }
    if (profile.companies && profile.companies.length > 0) {
      const firstCompany = profile.companies[0];
      if (firstCompany && firstCompany.managerId) {
        return firstCompany.managerId;
      }
    }
    return "---";
  };

  // Determinar si mostrar el botón hamburguesa (roles que tienen sidebar)
  const SIDEBAR_ROLES = [
    "COMPANY_ADMIN",
    "PARTICULAR_CLIENT",
    "RRHH",
    "RRHH_APPOINTMENTS",
    "CANDIDATE_APPOINTMENTS",
    "RRHH_APPOINTMENTS_AND_ABSENTEE",
    "RRHH_RESULT",
    "RRHH_ABSENTEE",
    "ADM_ABSENTEE",
    "ACCOUNTANT",
    "ASESOR",
  ];

  const showMobileMenuButton = SIDEBAR_ROLES.includes(chosenRole);
  const cuentaCorrienteSaldo = reduxStore?.cuentaCorrienteSaldo;
  const saldoNumero =
    cuentaCorrienteSaldo == null ? null : Number(cuentaCorrienteSaldo);
  const saldoVisible =
    saldoNumero == null || Number.isNaN(saldoNumero)
      ? null
      : Math.max(0, saldoNumero);
  const saldoFormateado =
    saldoVisible == null ? null : saldoVisible.toLocaleString("es-AR");
  const saldoEstado =
    saldoVisible == null ? null : saldoVisible > 0 ? "deuda" : "cero";
  const puedeIrACuentaCorriente =
    !isFranchise &&
    (chosenRole === "COMPANY_ADMIN" || chosenRole === "RRHH");

  return (
    <div className="navbar-atendoo">
      <div className="navbar-left">
        {/* Botón hamburguesa para mobile */}
        {showMobileMenuButton && onMobileMenuToggle && (
          <button
            className="mobile-menu-btn"
            onClick={onMobileMenuToggle}
            aria-label="Abrir menú"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        )}

        {/* ButtonBurger original para desktop */}
        <div className="desktop-burger">
          <ButtonBurger />
        </div>
      </div>

      <div className="navbar-saldo">
        {!isFranchise && saldoFormateado != null && (
          <>
            {puedeIrACuentaCorriente ? (
              <button
                type="button"
                className="navbar-saldo-label navbar-saldo-label--link"
                onClick={() => navigate(CUENTA_CORRIENTE)}
              >
                Saldo en cuenta corriente:
              </button>
            ) : (
              <span className="navbar-saldo-label">Saldo en cuenta corriente:</span>
            )}
            <span className={`navbar-saldo-valor navbar-saldo-valor--${saldoEstado}`}>
              {saldoEstado === "deuda" && (
                <TriangleAlert size={15} strokeWidth={2.25} aria-hidden="true" />
              )}
              <span>${saldoFormateado}</span>
              <span className="navbar-saldo-info">
                <button
                  type="button"
                  className="navbar-saldo-info-btn"
                  aria-label="Información de cuenta corriente"
                  aria-describedby="navbar-saldo-info-text"
                >
                  <Info size={15} strokeWidth={2.25} aria-hidden="true" />
                </button>
                <span id="navbar-saldo-info-text" className="navbar-saldo-info-text" role="tooltip">
                  <strong>¡Ahora podes consultar tu cuenta corriente desde el portal!</strong>
                  <span>
                    Ingresa a Cuenta corriente en el menú lateral para ver tu saldo vencido, y próximo a vencer.
                  </span>
                  <span>
                    En la pestaña Facturas, podes filtrar por fechas y descargar tus comprobantes.
                  </span>
                </span>
              </span>
            </span>
          </>
        )}
      </div>

      <div className="navbar-title">
        <div className="user-info d-none d-sm-flex flex-sm-column">
          <span className="welcome-text">
            Hola {chosenRole === "ASESOR" ? profile?.name : (profile?.companies && profile?.companies[0]?.socialReason || profile?.name || profile?.email)}!
          </span>
          <div className="role-info">
            {rolesDictionary[chosenRole] && (
              <span className="role-text">
                {rolesDictionary[chosenRole]}
              </span>
            )}
            {chosenRole !== "PARTICULAR_CLIENT" && (
              <>
                <span className="divider"> | </span>
                <span className="client-code">
                  Cliente: #{getCodClient()}
                </span>
              </>
            )}
            <span className="divider"> | </span>
            <TenantIndicator className="tenant-indicator tenant-indicator--navbar" />
          </div>
        </div>
        <div className="avatar-atendoo d-none d-sm-flex">
          {DROPDOWN[chosenRole] ? DROPDOWN[chosenRole] : <></>}
        </div>
        <div className="d-flex d-sm-none">
          <FranchiseLogo className="logo" />
        </div>
      </div>
    </div>
  );
}

export default React.memo(NavBar);
